import React from 'react'
import PropTypes from 'prop-types'
import TeamMemberCard from '../../Shared/TeamMemberCard/TeamMemberCard'

const AdvisorContactInfo = (props) => {
  const {
    contact,
    isMobile
  } = props

  return (
    <TeamMemberCard
      isMobile={isMobile}
      phoneType="mobile"
      name={contact.name}
      avatarSize="small"
      primaryText={contact.name}
      secondaryText={contact.title}
      infoPosition="right"
      phone={contact.mobilePhone}
      email={contact.email}
      isAuthor={true} />
  )
}

AdvisorContactInfo.propTypes = {
  contact: PropTypes.object,
  isMobile: PropTypes.bool
}

AdvisorContactInfo.defaultProps = {
  contact: {},
  isMobile: false
}

export default AdvisorContactInfo



// WEBPACK FOOTER //
// ./src/components/Client/WelcomeNotification/AdvisorContactInfo/AdvisorContactInfo.jsx